import { z } from 'zod';

const singleFaqSchema = z
  .object({
    faq_id: z.number(),
    faq_type: z.object({
      id: z.number(),
      name: z.string(),
    }),
    question: z.string(),
    answer: z.string(),
    priority: z.number(),
    created_at: z.string(),
    updated_at: z.string(),
  })
  .strict();

export type FAQ = z.infer<typeof singleFaqSchema>;

export const arrayFaqSchema = z.array(singleFaqSchema);
